<div class="thank-you-page">
  <div class="thank-you-container">
    <div class="thank-you-card">
      <img class="brand-logo" src="assets/img/logo-ls-black.png" alt="iN2Padel" />
      <p class="brand-name">iN2Padel</p>

      @if (paymentState === 'verifying') {
        <div class="state-block">
          <div class="spinner"></div>
          <h1>{{ 'THANK_YOU.states.verifying.title' | translate }}</h1>
          <p>{{ 'THANK_YOU.states.verifying.description' | translate }}</p>
        </div>
      }

      @if (paymentState === 'success') {
        <div class="state-block success">
          <div class="state-icon">&#10003;</div>
          <h1>{{ 'THANK_YOU.states.success.title' | translate }}</h1>
          <p>{{ 'THANK_YOU.states.success.description' | translate }}</p>

          <div class="payment-details">
            <span class="label">{{ 'THANK_YOU.amountLabel' | translate }}</span>
            <span class="value">
              @if (verificationCurrency === 'SAR') {
                <span class="icon-saudi_riyal">&#234;</span>
              } @else {
                <span class="currency">{{ verificationCurrency }}</span>
              }
              {{ verificationAmount | number:'1.2-2' }}
            </span>
          </div>

          <div class="action-row">
            <button type="button" class="btn-primary" (click)="goToMyBookings()">
              {{ 'THANK_YOU.actions.myBookings' | translate }}
            </button>

            @if (showCourtAction) {
              <button type="button" class="btn-secondary" (click)="goToCourt()">
                {{ 'THANK_YOU.actions.backToCourt' | translate }}
              </button>
            }
          </div>
        </div>
      }

      @if (paymentState === 'error') {
        <div class="state-block error">
          <div class="state-icon">!</div>
          <h1>{{ 'THANK_YOU.states.error.title' | translate }}</h1>
          <p>
            @if (errorMessage && errorMessage.startsWith('THANK_YOU.')) {
              {{ errorMessage | translate }}
            } @else if (errorMessage) {
              {{ errorMessage }}
            } @else {
              {{ 'THANK_YOU.states.error.generic' | translate }}
            }
          </p>

          <div class="action-row">
            <button type="button" class="btn-primary" (click)="goHome()">
              {{ 'THANK_YOU.actions.home' | translate }}
            </button>
            <button type="button" class="btn-secondary" (click)="goToMyBookings()">
              {{ 'THANK_YOU.actions.myBookings' | translate }}
            </button>
          </div>
        </div>
      }
    </div>
  </div>
</div>
